const ListingsItemHook = {
  mounted() {
    const id = this.el.dataset.buildingId;
    const map = document.getElementById('map');

    this.el.addEventListener('mouseenter', () => {
      const event = new CustomEvent('highlight-building', {
        detail: { highlight: true, id: id },
      });

      map.dispatchEvent(event);
    });

    this.el.addEventListener('mouseleave', () => {
      const event = new CustomEvent('highlight-building', {
        detail: { highlight: false, id: id },
      });

      map.dispatchEvent(event);
    });
  },
};

export default ListingsItemHook;
